import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import React, { useState, useEffect } from 'react';
import { useStyles } from '../styles/Styles';

const filter = createFilterOptions();
/**
   * Autocomplete
   * @param getOptions async () 
   * @param onChange function
   * @param {String} createLabel
   * @param {boolean} disabled - optional, default false
   */
export default function MyAutocomplete(props) {
    const classes = useStyles(props, "autocomplete")();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    useEffect(function () {
        // console.log(props);
    }, []);

    const onOpen = () => {
        setOpen(true);
        props.getOptions()
            .then(res => {
                if (res.length === 0) {
                    res.push({ label: "Nincs Találat", value: "notavalidoption" })

                }
                setLoading(false);
                setOptions(res);
            });
    }

    const filterOptions = (options, params) => {
        var filtered = filter(options, params);
        if (typeof props.customFilter == 'function') {
            filtered = (props.customFilter(options, params))
        }
        // Suggest the creation of a new value
        if (props.createLabel && filtered.length === 0 && params.inputValue !== '') {
            if (typeof props.validate == 'function') {
                // console.log(params.inputValue)
                if (props.validate(params.inputValue)) {
                    filtered.push({
                        inputValue: params.inputValue,
                        label: `${props.createLabel}: ${params.inputValue}`,
                    });
                } else {
                    filtered.push({
                        value: "notavalidoption",
                        label: `Formátum: ${props.formatHint}`,
                    });
                }
            } else {
                filtered.push({
                    inputValue: params.inputValue,
                    label: `${props.createLabel}: ${params.inputValue}`,
                });
            }
        }
        return filtered;
    }

    const getOptionSelected = (option, value) => {
        return option.label === value.label
    }

    const getOptionLabel = (option) => {
        if (option && option.label) {
            return option.label
        } else {
            return "";
        }
    }

    const isDisabled = () => {
        if (props.disabled) {
            return props.disabled;
        } else {
            return false;
        }
    }

    const getRenderOption = (option, { selected }) => {
        if (props.renderOption && "notavalidoption" !== option.value) {
            return props.renderOption(option, { selected });
        } else {
            return <>{option.label}</>
        }
    }

    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && props.prevValue.label && props.value && props.value.label !== props.prevValue.label) {
            return props.prevValue.label;
        } else {
            return "";
        }
    }

    return (
        <>
            {!(props.hidden && props.hidden === true) ?
                <Autocomplete
                    freeSolo
                    clearOnBlur
                    defaultValue={props.defaultValue}
                    getOptionDisabled={(option) => option.value === "notavalidoption"}
                    name={props.name}
                    value={props.value}
                    autoComplete={true}
                    autoHighlight={true}
                    fullWidth
                    loading={loading}
                    onChange={props.onChange}
                    options={options}
                    getOptionSelected={getOptionSelected}
                    getOptionLabel={getOptionLabel}
                    filterOptions={filterOptions}
                    onOpen={onOpen}
                    onClose={() => setOpen(false)}
                    disabled={isDisabled()}
                    noOptionsText="Nincs találat"
                    renderOption={getRenderOption}
                    className={classes.root}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            required={props.required !== undefined ? props.required : true}
                            label={props.label}
                            size={props.size}
                            helperText={helperText()}
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                />
                : <></>}
        </>
    );
}